import {
  FormControl,
  FormLabel,
  FormHelperText,
  Textarea,
} from "@chakra-ui/react";

export default function TextareaComponent({
  label,
  type,
  value,
  onChange,
  placeholder,
  readOnly,
  border,
  p,
  required = true,
  rows,
  isDisabled = false,
}) {
  return (
    <FormControl isDisabled={isDisabled} isRequired={required}>
      <FormLabel fontWeight="medium" color="var(--container_color)">
        {label}
      </FormLabel>
      <Textarea
        readOnly={readOnly ? readOnly : false}
        type={type}
        color="#000"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        focusBorderColor="brand.900"
        border={border ? border : "1px solid #ccc"}
        p={p ? p : ""}
        rows={rows}
        bg="white"
      />
      {false && <FormHelperText>We'll never share your email.</FormHelperText>}
    </FormControl>
  );
}
